import { useEffect, useState } from 'react'
import { Box, styled } from '@mui/material'

import { useAppDispatch } from 'app/state'
import { HeaderBaseProps } from '../types'

import CartoAppBar from './CartoAppBar'

import HeaderNotifications from './Partials/HeaderNotifications'
import HeaderJobsStatusIndicator from './Partials/HeaderJobsStatusIndicator'
import OnboardingChecklist from 'features/onboarding-checklist/ui/OnboardingChecklist'
import HelpPanel from 'features/help-panel/ui/HelpPanel'
import UserInfo from './Partials/UserInfo/UserInfo'

import { getOnboardingChecklistRequest } from 'features/onboarding-checklist/state/onboardingChecklistSlice'
import useOnboardingChecklist from 'features/onboarding-checklist/utils/useOnboardingChecklist'
import BreakpointsDebug from './Partials/BreakpointsDebug'
import PartnerConnectDialog from 'features/sf-connect-tasks/ui/PartnerConnectDialog'
import { RequestStatus } from 'features/common/types'

const AlignedBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center'
}))

function HeaderBase({
  actions,
  brandLogo,
  brandText,
  secondaryText,
  showDrawerButton,
  headerInfo,
  showWorkspaceButton,
  handleDrawerVisibility,
  jobs
}: HeaderBaseProps) {
  const dispatch = useAppDispatch()
  const [isNotificationEnabled] = useState(false)
  const { isUserOnboarding, onBoardingCheckListStatus } = useOnboardingChecklist()

  useEffect(() => {
    if (onBoardingCheckListStatus === RequestStatus.Idle) {
      dispatch(getOnboardingChecklistRequest())
    }
  }, [dispatch, onBoardingCheckListStatus])
  return (
    <CartoAppBar
      showDrawerButton={showDrawerButton}
      handleDrawerVisibility={handleDrawerVisibility}
      brandLogo={brandLogo}
      brandText={brandText}
      secondaryText={secondaryText}
    >
      <AlignedBox mr={1}>
        {headerInfo && headerInfo}
        {import.meta.env.DEV && <BreakpointsDebug />}
      </AlignedBox>

      <AlignedBox>
        {!!actions && <AlignedBox>{actions}</AlignedBox>}
        {isNotificationEnabled && (
          <Box ml={1}>
            <HeaderNotifications />
          </Box>
        )}

        {jobs !== false && <HeaderJobsStatusIndicator />}

        {isUserOnboarding && (
          <Box ml={1}>
            <OnboardingChecklist />
          </Box>
        )}

        <Box ml={1}>
          <HelpPanel />
        </Box>

        <Box ml={1}>
          <UserInfo showWorkspaceButton={showWorkspaceButton} />
        </Box>

        <PartnerConnectDialog />
      </AlignedBox>
    </CartoAppBar>
  )
}

export default HeaderBase
